import { NormalButton } from "@components/General/Button"
import { VerticalContainer, VerticalSpacer } from "@components/General/Containers"
import { Text } from "@components/General/Texts"
import { H2Title } from "@components/General/Titles"
import designSystem from "@styles/designSystem"

interface PromotionalScreenProps {
    onClick?: () => void;
}

export const PromotionalScreen: React.FC<PromotionalScreenProps> = (props) => {
    const handleWhatsAppClick = () => {
        props.onClick()
        //https://wa.me/5491154059639?text=Hola%2C%20vengo%20de%20hacer%20la%20demo%20en%20la%20web%2C%20me%20gustar%C3%ADa%20iniciar%20la%20prueba%20gratuita%20de%20Qontact
        // const phoneNumber = "5491154059639" // Without the + sign
        const phoneNumber = "5491156468407" // Without the + sign
        const message = encodeURIComponent("Hola, vengo de hacer la demo en la web, me gustaría iniciar la prueba gratuita de Qontact".localized())
        window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank')
    }

    return (
        <VerticalContainer height={'100%'} gap={designSystem.gapSm}>
            <VerticalContainer gap={designSystem.paddingZero}>
                <H2Title text={"¿Querés utilizar Qontact?".localized()}/>
            </VerticalContainer>
            <Text 
                text={"Comunicate con nuestro equipo para iniciar tu prueba gratuita y transformar la manera en la que controlas la asistencia en tu empresa.".localized()}
                markdown={true}
            />
            <VerticalSpacer/>
            <VerticalContainer width={'100%'} alignment={'center'}>
                <NormalButton 
                    width={'300px'}
                    text={"Contactar".localized()}
                    onClick={handleWhatsAppClick}
                />
            </VerticalContainer>
        </VerticalContainer>
    )
}